import React, { useRef, useState } from "react";
import { DefaultLogos, MainHeader, MainHeaderSeparator } from "pu-crossproduct-components/build/components/Organisms/HeadersFooters/MainHeader";
import { IconButton, IconButtonSize, Icons } from "pu-crossproduct-components/build/components/Molecules/Navigation/IconButton";
import { Menu, AlignToAnchor, PositionToAnchor } from "pu-crossproduct-components/build/components/Organisms/Inputs/Menu";
import { MenuCheckboxItem, MenuDivider, MenuIconItem, MenuItem, MenuSearch } from "pu-crossproduct-components/build/components/Molecules/Inputs/Menu";
import { useHistory } from "react-router-dom";
import styled from "styled-components";


const Header = styled.div`
  z-index: 5;
`

export const InformatHeader: React.FC = (props) => {
    const [isMenuExpanded, setMenuExpanded] = useState(false);
    const ref = useRef(null);
    const history = useHistory();

    function handleSearch(search: string) {
        history.push(`/search/${search}`);
    }

    return (
        <Header>
            <MainHeader
                logo={DefaultLogos.default}
                context={
                    <>
                        <MainHeaderSeparator />
                        <div ref={ref} style={{ position: 'relative' }}>
                            <IconButton size={IconButtonSize.medium} icon={Icons.lifeRingRegular} onclick={() => {
                                setMenuExpanded(!isMenuExpanded);
                            }} />
                        </div>
                    </>
                }>
            </MainHeader>
            <Menu
                menuSearch={<MenuSearch label='Doorzoek helpdesk artikels' onSearch={(search) => {
                    window.open(`https://helpdesk.informat.be/hc/nl/search?utf8=✓&query=${search}&commit=Zoeken`);
                    setMenuExpanded(false);
                    return true;
                }} />}
                triggerRef={ref}
                open={isMenuExpanded}
                positionToAnchor={PositionToAnchor.BottomRight}
                alignToAnchor={AlignToAnchor.Right}
                onClose={() => { setMenuExpanded(false); }} >
                <MenuItem label="Support" onClick={() => {
                    setMenuExpanded(false);
                    window.open(`https://helpdesk.informat.be/`);
                }} />
                <MenuItem label="Contact" onClick={() => {
                    setMenuExpanded(false);
                    window.open(`https://www.informat.be/support/`)
                }} />
            </Menu>
        </Header>
    )
}